'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import PropTypes from 'prop-types';
import * as CustomRenderer from 'UIComponents/utils/propTypes/customRenderer';
import ModuleCompatibilityTagTypes from 'marketplace-lib/constants/ModuleCompatibilityTagTypes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIList from 'UIComponents/list/UIList';
var ANY_COMPATIBILITY = Object.freeze([ModuleCompatibilityTagTypes.COMPATIBLE_BLOG, ModuleCompatibilityTagTypes.COMPATIBLE_EMAIL, ModuleCompatibilityTagTypes.COMPATIBLE_PAGE]);

var DefaultTagComponent = function DefaultTagComponent(_ref) {
  var tagTitle = _ref.tagTitle;
  return tagTitle;
};

var ModuleCompatibilityTagsList = /*#__PURE__*/function (_Component) {
  _inherits(ModuleCompatibilityTagsList, _Component);

  function ModuleCompatibilityTagsList() {
    _classCallCheck(this, ModuleCompatibilityTagsList);

    return _possibleConstructorReturn(this, _getPrototypeOf(ModuleCompatibilityTagsList).apply(this, arguments));
  }

  _createClass(ModuleCompatibilityTagsList, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return shallowCompare(this, nextProps, nextState);
    }
  }, {
    key: "renderTag",
    value: function renderTag(tag, TagComponent) {
      return CustomRenderer.render(TagComponent, {
        key: tag,
        tag: tag,
        tagTitle: React.createElement(FormattedMessage, {
          message: "marketplacelib.ModuleCompatibilityTagTypes." + tag
        })
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          ListComponent = _this$props.listComponent,
          _moduleCompatibility = _this$props.moduleCompatibility,
          TagComponent = _this$props.tagComponent,
          rest = _objectWithoutProperties(_this$props, ["listComponent", "moduleCompatibility", "tagComponent"]);

      var moduleCompatibility = _moduleCompatibility;

      if (moduleCompatibility.includes(ModuleCompatibilityTagTypes.COMPATIBLE_ANY)) {
        moduleCompatibility = ANY_COMPATIBILITY;
      }

      var renderedTags = moduleCompatibility.map(function (tagKey) {
        return _this.renderTag(tagKey, TagComponent);
      });
      return React.createElement(ListComponent, rest, renderedTags);
    }
  }]);

  return ModuleCompatibilityTagsList;
}(Component);

ModuleCompatibilityTagsList.propTypes = {
  listComponent: CustomRenderer.propType.isRequired,
  moduleCompatibility: PropTypes.arrayOf(PropTypes.oneOf(Object.keys(ModuleCompatibilityTagTypes))).isRequired,
  tagComponent: CustomRenderer.propType.isRequired
};
ModuleCompatibilityTagsList.defaultProps = {
  listComponent: UIList,
  tagComponent: DefaultTagComponent
};
export default ModuleCompatibilityTagsList;